import { render, staticRenderFns } from "./EditVideo.vue?vue&type=template&id=5026d0aa&scoped=true"
import script from "./EditVideo.vue?vue&type=script&lang=js"
export * from "./EditVideo.vue?vue&type=script&lang=js"
import style0 from "./EditVideo.vue?vue&type=style&index=0&id=5026d0aa&prod&lang=css"
import style1 from "./EditVideo.vue?vue&type=style&index=1&id=5026d0aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5026d0aa",
  null
  
)

export default component.exports